import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useUpdateNotificationSettingsMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.updateNotificationSettings,
		onSuccess: (t) => {
			i.setQueryData(e.settings(), t);
		}
	});
};
//#endregion
export { i as useUpdateNotificationSettingsMutation };
